module.exports = __webpack_public_path__ + "f21eb91bae032ba41049766d1209d53a.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/iphone.png
// module id = 689
// module chunks = 0